export const getDatePlusTime = (date: string): string => {
  let hours = new Date().getHours();
  let minutes = new Date().getMinutes();
  return `${date} ${hours}:${minutes < 10 ? "0" : ""}${minutes}`;
};
